import React, { useEffect } from 'react'

import { CommonRoutes, ProtectedRoutes } from './routes'
import { Header } from './layouts/header'

import classes from './styles/header.module.scss'
import { useSelector } from './hooks/redux'
import { useDispatch } from './hooks/redux'
import { NotifyPortal } from './components/notify'
import { login } from './store/slices/user/async'

const POLL_INTERVAL = 30_000

export const App = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user.user)

  useEffect(() => {
    if (!user.auth_token) return

    const id = setInterval(() => {
      dispatch(login(user.auth_token))
    }, POLL_INTERVAL)

    return () => clearInterval(id)
  }, [user.auth_token])

  return (
    <>
      <div className={classes.mainBackground} />
      {user.auth_token ? (
        <>
          <Header />
          <ProtectedRoutes user={user} />
        </>
      ) : (
        <CommonRoutes />
      )}
      <NotifyPortal />
    </>
  )
}
